import { FrameBlockComponent } from './frame-block';

export function effects() {
  customElements.define('affine-frame', FrameBlockComponent);
}
